export const buildUrlFromString = (string: string) =>
  string.match(/^https?/) ? string : `http://${string}`;
